// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"348":"0b060ba536a579a8dd0c","471":"5ddda6d4a08c14c3d5f0","473":"f4d6627b79d72273983a","860":"3591eebbb65bc9cf50e1"}[chunkId] + ".js";
};